module.exports = "/images/tv.png?af133f5780abfac700c2989ba864d765";